var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "liker-item-component LikerItem" }, [
    _c(
      "a",
      {
        staticClass: "item-info",
        attrs: { href: _vm.profileUrl },
        on: { click: _vm.goToProfile }
      },
      [
        _c("CoverImg", { attrs: { src: _vm.liker.avatar, height_ratio: 1 } }),
        _vm._v(" "),
        _c("div", { staticClass: "user-name" }, [
          _vm._v(_vm._s(_vm.liker.full_name))
        ])
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isCurrent
      ? _c(
          "div",
          { staticClass: "item-actions" },
          [
            _c("FollowBtn", {
              attrs: { short: false, user: _vm.liker },
              on: {
                is_following: function($event) {
                  _vm.liker.is_following = $event
                }
              }
            }),
            _vm._v(" "),
            _c("AddFriendBtn", {
              attrs: { short: false, user: _vm.liker },
              on: {
                is_friend: function($event) {
                  _vm.liker.is_friend = $event
                },
                friend_status: function($event) {
                  _vm.liker.friend_status = $event
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }